import '@/vendors/pano2vr_player';
import Pano2vrSkin from '@/vendors/pano2vr_skin';
import detector from '@/vendors/pano2vr_detector';

const { $ } = window;
// const Detector = require('lib/Detector');

export default class Interior360 {
  constructor($this, carname) {
    this.$this = $this;
    this.carname = carname;

    const $script = $this.children('script');
    this.source = JSON.parse($script.text());

    $this.find('a.start').click((e) => {
      e.preventDefault();
      console.log('start');

      if (!detector.webgl) {
        // eslint-disable-next-line no-alert
        window.alert('您的瀏覽器版本或硬體規格不支援！');
        return;
      }

      if (!this.source) {
        // eslint-disable-next-line no-alert
        window.alert('沒有材質！！！');
        return;
      }

      $(e.currentTarget).remove();
      // window.gaev('btn', 'click', `btn_${this.carname}_interior_360`);

      if (!!this.source.type && this.source.type === 'pano2vr') {
        const id = `pano2vr${99999 * Math.random()}`;
        $this.empty().attr('id', id).css('z-index', 5);
        // eslint-disable-next-line no-undef, new-cap
        this.pano = new pano2vrPlayer(id);
        this.skin = new Pano2vrSkin(this.pano, '/');
        this.pano.readConfigUrlAsync(this.source.xml);
        this.mobileDynamicZindex();
      } else console.error('ERROR: source type not found!');
    });
  }

  mobileDynamicZindex() {
    this.$this.on('touchstart', '.ggskin.ggskin_svg', () => {
      this.detectFullscreen();
    });

    $(window).on('orientationchange', () => {
      this.detectFullscreen();
    });
  }

  detectFullscreen() {
    setTimeout(() => {
      if (!this.$this || !this.pano) return;
      this.$this.css('z-index', this.pano.getIsFullscreen() ? 100 : 5);
    }, 500);
  }
}
